import React, { useState } from 'react'

export default function UiAmountTile({ data }) {

    const [selectedIndex, setSelectedIndex] = useState(0);

    return (
        <div>
            {data.map((item, index) => {
                return (
                    <div
                        key={index}
                        onClick={() => setSelectedIndex(index)}
                        className={selectedIndex === index ? "sb-amount-tile sb-amount-tile__selected" : "sb-amount-tile"}>
                        <span>{item}</span>
                    </div>
                );
            })}
        </div>
    );




}
